// defs
import { ISimulationInput } from "@defs/Utilities";
import { AllocationType, InputType } from "@utils/appsync/schema/API";
import { Scenario, Sim } from "@utils/appsync/schema/API";
import { IStepper } from "@components/Stepper/Stepper.props";

// constants
import {
    GL_SIMULATION_SIMULATION_INPUTS,
    GL_SIMULATION_STEPPERS,
    GLSimulationSteppersType,
} from "@pages/simulations/NewSimulation/containers/GLSimulation/constants";
import {
    OPEX_ALLOCATION_STEPPERS,
    OpexAllocationSteppersType,
    OPEX_ALLOCATION_SIMULATION_INPUTS,
} from "@pages/simulations/NewSimulation/containers/OpexAllocation/constants";

// helpers
import { createDeepCopy } from "@utils/index";

export interface INewSimulationState {
    readOnly: boolean;
    simulationId?: string;
    simulationData: Partial<Sim>;
    selectedScenario?: Scenario;
    selectedCostPoolList?: Array<string>;
    scenarioList: Array<Scenario>;
    isSystemDefinitionAndMappingSelected: boolean;
    activeSimulationStepper: IStepper<OpexAllocationSteppersType | GLSimulationSteppersType>;
    simulationSteppers: Array<IStepper<OpexAllocationSteppersType | GLSimulationSteppersType>>;
    simulationInputs: Array<ISimulationInput<InputType>>;
}

export const getInitialNewSimulationState = (allocationType = AllocationType.opex_allocation): INewSimulationState => ({
    readOnly: false,
    simulationId: undefined,
    simulationData: {},
    selectedScenario: undefined,
    scenarioList: [],
    selectedCostPoolList: [],
    isSystemDefinitionAndMappingSelected: true,
    simulationSteppers: createDeepCopy(
        allocationType === AllocationType.opex_allocation ? OPEX_ALLOCATION_STEPPERS : GL_SIMULATION_STEPPERS,
    ),
    activeSimulationStepper: createDeepCopy(OPEX_ALLOCATION_STEPPERS[0]),
    simulationInputs:
        allocationType === AllocationType.opex_allocation ? OPEX_ALLOCATION_SIMULATION_INPUTS : GL_SIMULATION_SIMULATION_INPUTS,
});
